<template>
  <section v-if="groups.length" class="clinic-features">
    <h2 class="clinic-features__title">Оснащение и условия</h2>
    <div v-for="group in groups" :key="group.key" class="clinic-features__block">
      <p class="clinic-features__block-title">{{ group.label }}</p>
      <ClinicFeatureIcons
          v-if="group.codes?.length"
          :codes="group.codes"
          labeled
      />
      <div v-else class="clinic-features__tags">
        <span v-for="item in group.items" :key="item" class="clinic-features__tag">{{ item }}</span>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import type {TClinicFeatureBlock} from '~/types/clinic';

defineProps<{
  groups: TClinicFeatureBlock[];
}>();
</script>

<style lang="scss">
.clinic-features {
  &__title {
    margin: 0 0 16px;
    font-size: 20px;
    font-weight: 500;
    line-height: 1.2;
    color: $color-black;
    text-align: left;
  }

  &__block {
    margin-bottom: 20px;
    width: 100%;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__block-title {
    margin: 0 0 8px;
    font-size: 15px;
    font-weight: 500;
    line-height: 1.3;
    color: $color-gray;
  }

  &__tags {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }

  &__tag {
    display: inline-flex;
    align-items: center;
    padding: 4px 8px;
    border-radius: 6px;
    background: $color-dark-white;
    color: $color-gray;
    font-size: 12px;
    font-weight: 400;
    line-height: 1.3;
  }
}
</style>
